var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampaignUnavailable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 717.606,
    height: 351.426,
    viewBox: "0 0 717.606 351.426",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Campaign_Unavailable",
    "data-name": "Campaign Unavailable",
    transform: "translate(1.002 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(-0.002 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Presentation-board",
    transform: "translate(350.123 349.53) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M50.192,242.69,6.685,0H0L43.507,242.69Z",
    transform: "translate(110.623)",
    fill: "#9999da",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M50.192,242.69,6.685,0H0L43.507,242.69Z",
    transform: "translate(108.61)",
    fill: "#cfcff8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M51.745,251.348,6.685,0H0L45.06,251.348Z",
    transform: "translate(2.819)",
    fill: "#9999da",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M51.745,251.348,6.685,0H0L45.06,251.348Z",
    transform: "translate(0.805)",
    fill: "#cfcff8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M.805,5.638h9.866a.805.805,0,0,0,.805-.805V.805A.805.805,0,0,0,10.672,0H.805A.805.805,0,0,0,0,.805V4.833A.805.805,0,0,0,.805,5.638Z",
    transform: "translate(0 0.04)",
    fill: "#0f0a57",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    d: "M6.685,146.012H0L18.579,0h6.685Z",
    transform: "translate(54.263)",
    fill: "#9999da",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    "data-name": "Shape",
    d: "M6.685,146.012H0L18.579,0h6.685Z",
    transform: "translate(52.25)",
    fill: "#cfcff8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-8",
    "data-name": "Shape",
    d: "M.805,5.638h9.866a.805.805,0,0,0,.805-.805V.805A.805.805,0,0,0,10.672,0H.805A.805.805,0,0,0,0,.805V4.833A.805.805,0,0,0,.805,5.638Z",
    transform: "translate(68.863 0.04)",
    fill: "#0f0a57",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-9",
    "data-name": "Shape",
    d: "M.805,5.638h9.866a.805.805,0,0,0,.805-.805V.805A.805.805,0,0,0,10.672,0H.805A.805.805,0,0,0,0,.805V4.833A.805.805,0,0,0,.805,5.638Z",
    transform: "translate(107.926 0.04)",
    fill: "#0f0a57",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-10",
    "data-name": "Shape",
    d: "M6.685,242.69,32.053,0H25.368L0,242.69Z",
    transform: "translate(153.596)",
    fill: "#9999da",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-11",
    "data-name": "Shape",
    d: "M6.685,242.69,32.053,0H25.368L0,242.69Z",
    transform: "translate(151.582)",
    fill: "#cfcff8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-12",
    "data-name": "Shape",
    d: "M.805,5.638h9.866a.805.805,0,0,0,.805-.805V.805A.805.805,0,0,0,10.672,0H.805A.805.805,0,0,0,0,.805V4.833A.805.805,0,0,0,.805,5.638Z",
    transform: "translate(174.978 0.04)",
    fill: "#0f0a57",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-13",
    "data-name": "Shape",
    d: "M37.061,200.08h133.3a2.014,2.014,0,0,0,1.982-2.368L137.293,1.659A2.014,2.014,0,0,0,135.311,0H2.014A2.014,2.014,0,0,0,.031,2.368L35.079,198.421A2.014,2.014,0,0,0,37.061,200.08Z",
    transform: "translate(8.978 91.945)",
    fill: "#bd6130",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-14",
    "data-name": "Shape",
    d: "M37.061,200.08h133.3a2.014,2.014,0,0,0,1.982-2.368L137.293,1.659A2.014,2.014,0,0,0,135.311,0H2.014A2.014,2.014,0,0,0,.031,2.368L35.079,198.421A2.014,2.014,0,0,0,37.061,200.08Z",
    transform: "translate(2.937 91.945)",
    fill: "#e68e60",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-15",
    "data-name": "Shape",
    d: "M33.92,188H159.228L125.307,0H0Z",
    transform: "translate(9.572 97.986)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-16",
    "data-name": "Shape",
    d: "M5.253,22.151H24.026a1.314,1.314,0,0,0,1.319-1.617L22.008,1.617A2.005,2.005,0,0,0,20.118,0H1.345A1.314,1.314,0,0,0,.025,1.617L3.363,20.534A2.005,2.005,0,0,0,5.253,22.151Z",
    transform: "translate(49.533 254.973)",
    fill: "#4ad9c5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-17",
    "data-name": "Shape",
    d: "M5.253,22.151H24.026a1.314,1.314,0,0,0,1.319-1.617L22.008,1.617A2.005,2.005,0,0,0,20.118,0H1.345A1.314,1.314,0,0,0,.025,1.617L3.363,20.534A2.005,2.005,0,0,0,5.253,22.151Z",
    transform: "translate(43.291 217.72)",
    fill: "#ff5711",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-18",
    "data-name": "Shape",
    d: "M5.253,22.151H24.026a1.314,1.314,0,0,0,1.319-1.617L22.008,1.617A2.005,2.005,0,0,0,20.118,0H1.345A1.314,1.314,0,0,0,.025,1.617L3.363,20.534A2.005,2.005,0,0,0,5.253,22.151Z",
    transform: "translate(124.438 232.822)",
    fill: "#bf8df2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-19",
    "data-name": "Shape",
    d: "M18.965,1.208H.6A.6.6,0,0,1,.6,0H19.459a.6.6,0,0,1,.592.484l7.968,39.161a.6.6,0,0,1-.592.725h-19a.6.6,0,0,1,0-1.208H26.687Z",
    transform: "translate(75.106 226.284)",
    fill: "#0f0a57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-20",
    "data-name": "Shape",
    d: "M.6,0h19.4a.6.6,0,0,1,0,1.208H.6A.6.6,0,0,1,.6,0Z",
    transform: "translate(97.961 244.888)",
    fill: "#0f0a57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-21",
    "data-name": "Shape",
    d: "M1.479,6.645H45.361a.4.4,0,0,0,.4-.476L44.681.33a.4.4,0,0,0-.4-.33H.4a.4.4,0,0,0-.4.476l1.077,5.84A.4.4,0,0,0,1.479,6.645Z",
    transform: "translate(39.345 195.972)",
    fill: "#e5e5ed",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-22",
    "data-name": "Shape",
    d: "M1.479,6.645H67.51a.4.4,0,0,0,.4-.476L66.83.33a.4.4,0,0,0-.4-.33H.4a.4.4,0,0,0-.4.476l1.077,5.84A.4.4,0,0,0,1.479,6.645Z",
    transform: "translate(33.707 167.378)",
    fill: "#e5e5ed",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-23",
    "data-name": "Shape",
    d: "M1.479,6.645H99.727a.4.4,0,0,0,.4-.476L99.047.33a.4.4,0,0,0-.4-.33H.4a.4.4,0,0,0-.4.476l1.077,5.84A.4.4,0,0,0,1.479,6.645Z",
    transform: "translate(36.325 181.675)",
    fill: "#e5e5ed",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-24",
    "data-name": "Shape",
    d: "M3.681,20.137H16.366L12.685,0H0Z",
    transform: "translate(66.85 107.37)",
    fill: "#ff5711",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-25",
    "data-name": "Shape",
    d: "M8.834,48.329H21.519L12.685,0H0Z",
    transform: "translate(45.104 107.37)",
    fill: "#bf8df2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-26",
    "data-name": "Shape",
    d: "M5.227,28.594H17.912L12.685,0H0Z",
    transform: "translate(23.357 107.37)",
    fill: "#4ad9c5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-27",
    "data-name": "Shape",
    d: "M8.834,48.329H21.519L12.685,0H0Z",
    transform: "translate(110.343 107.37)",
    fill: "#fe9b04",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-28",
    "data-name": "Shape",
    d: "M6.221,34.031H18.906L12.685,0H0Z",
    transform: "translate(88.596 107.37)",
    fill: "#4849e1",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Round-Table",
    transform: "translate(16.406 147.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-29",
    "data-name": "Shape",
    d: "M102,19h13.844V207.718H102Z",
    transform: "translate(-27.679 -5.156)",
    fill: "#e68e60",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-30",
    "data-name": "Shape",
    d: "M6.948,0H155.539a6.922,6.922,0,1,1,0,13.844H6.948A6.922,6.922,0,1,1,6.948,0Z",
    fill: "#e68e60",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-31",
    "data-name": "Shape",
    d: "M69,19h61.934v6.922a6.925,6.925,0,0,1-6.929,6.922H75.929A6.925,6.925,0,0,1,69,25.922Z",
    transform: "translate(-18.724 -5.156)",
    fill: "#ca6d3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-32",
    "data-name": "Shape",
    d: "M69,272.844h61.934v-6.922A6.925,6.925,0,0,0,124.006,259H75.929A6.925,6.925,0,0,0,69,265.922Z",
    transform: "translate(-18.724 -70.282)",
    fill: "#ca6d3c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Laptop",
    transform: "translate(27.335 88.837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ICONSPACE",
    d: "M125.326,73H0v5.1H125.326Z",
    transform: "translate(0 -19.809)",
    fill: "#aeaeca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ICONSPACE-2",
    "data-name": "ICONSPACE",
    d: "M152.9,0H65.26a2.649,2.649,0,0,0-2.625,2.292L55,58.291h92.99l7.538-55.284A2.649,2.649,0,0,0,152.9,0Z",
    transform: "translate(-14.925)",
    fill: "#d9d9e0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ICONSPACE-3",
    "data-name": "ICONSPACE",
    d: "M120.273,44.3a9.493,9.493,0,0,0,8.9-7.651c.761-4.225-1.991-7.651-6.146-7.651a9.493,9.493,0,0,0-8.9,7.651C113.365,40.876,116.117,44.3,120.273,44.3Z",
    transform: "translate(-30.935 -7.869)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Problem-Found",
    transform: "translate(273.63 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Men-Confused",
    transform: "translate(135.502 349.387) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-33",
    "data-name": "Shape",
    d: "M14.879,0,19.1,4.255v15.1H0V0Z",
    transform: "translate(33.172 10.072)",
    fill: "#ffd3c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-34",
    "data-name": "Shape",
    d: "M15.1,0l4.225,4.255v15.1H0V0Z",
    transform: "translate(76.493 10.072)",
    fill: "#ffd3c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-35",
    "data-name": "Shape",
    d: "M36.212,119.934,45.234,1.621A43.269,43.269,0,0,1,57.458,0,36.329,36.329,0,0,1,68.986,1.621l.1,79.554,2.158,87.464Q4.3,169.549,4.3,169.8c.161,0-4.3-70.216-4.3-88.634Q0,62.754.856,1.621,5.367,0,13.634,0t12.5,1.621l3.439,78.551Z",
    transform: "translate(28.698 25.31)",
    fill: "#ff5711",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-36",
    "data-name": "Shape",
    d: "M7.494,15.355c-1.907.288-4.1-2.967-3.762-7.754L4.16,1.515a1.421,1.421,0,0,0-2.792-.458A44.419,44.419,0,0,0,.017,9.275c-.341,4.864,4.64,7.3,7.024,6.888l.189-.034.121-.023Q9.292,15.721,7.494,15.355Z",
    transform: "translate(3.778 174.958)",
    fill: "#f3baaa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-37",
    "data-name": "Shape",
    d: "M14.268,35.581l11.987-8.537-.283-.271q-6.158-5.936-7.135-10.383l-.022-.1a26.908,26.908,0,0,0-4.784-10c-1.1-1.449-4.345-1.822-2.818,2.093l.048.12c1.64,4.043,1.024,6.622-1.608,5.047C7.074,12,4.075,4.724,3.266,1.962L3.219,1.8C2.494-.8-.426-.569.053,2.4l.081.459L.207,3.3c.551,3.3,1.368,9.2,3.025,12.632a99.366,99.366,0,0,0,7.336,12.016l.216.322A22.035,22.035,0,0,1,14.268,35.581Z",
    transform: "translate(0 176.321)",
    fill: "#ffd3c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-38",
    "data-name": "Shape",
    d: "M0,32.248c1.183-1.468,5.164-2.116,6.254-1.468L8.13,6.021,7.123,0Z",
    transform: "translate(56.78 139.223)",
    fill: "#e14300",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-39",
    "data-name": "Shape",
    d: "M22.82,0c-2.8,2.815-6.287,2.687-8.035,2.817l-.054,0A27.588,27.588,0,0,0,8.972,4l-.1.036C7.4,4.55,4.683,5.967,4.987,6.9s1.307,1.114,2.741.616l.2-.071L8.058,7.4l.131-.042c1.427-.453,3.2-.675,3.7.47.388.878-.806,1.939-2.253,2.9L7,12.1l-1.07.55q-3.121,1.6-4.348,2.165C-.885,15.95.179,18.658,3.1,17.506l.4-.16.354-.145q2.659-1.095,7.991-3.551l.054.131-6.19,3.486q-3.55,2.009-4.581,2.627c-1.9,1.14-1.506,3.915,1.949,2.277l2.5-1.178q3.076-1.44,7.791-3.618l.013.032-1.921,1.176q-4.43,2.724-5.088,3.266l-.308.266-.1.087a1.3,1.3,0,0,0-.277,1.969c.765,1.13,2.189.145,3.432-.579l6.037-3.7-3,2.69-.848.8-.42.4-.268.259-.186.185a1.2,1.2,0,0,0,.212,2.009c.611.4,2.239-.521,3.646-1.651l1.116-.8.736-.537c2.065-1.514,4.828-3.628,5.533-4.664l.19-.283.109-.159a38.108,38.108,0,0,1,7.645-7.993Z",
    transform: "translate(60.383 322.532)",
    fill: "#ffd3c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-40",
    "data-name": "Shape",
    d: "M32.08,27.04C26.115,17.677,22.615,11.872,14.4,0,7.745,1.038.517,6.085,0,8.377L16.181,43.514,17.754,70Q20.551,96.642,44.4,96.68L40.183,48.562q-.559-9.629-7-19.791Z",
    transform: "translate(8.859 196.736)",
    fill: "#292560",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-41",
    "data-name": "Shape",
    d: "M5.026,70.273l14.854-32.32A43.2,43.2,0,0,0,13.095,20.4l-1.076-1.686C7.624,11.819,4.571,6.857,0,0Q4.036,34.552,5.026,70.273Z",
    transform: "translate(28.955 205.113)",
    fill: "#030211",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-42",
    "data-name": "Shape",
    d: "M20.851,107.054l25.326-1.063A20.4,20.4,0,0,0,65.748,85.055l-.039-1.392q-.323-11.9-.323-26.107V56.52q.053-21.561,2.3-47.443l.055-.624a4.425,4.425,0,0,0-2.693-4.462Q55.6,0,34.46,0,13.245,0,2.993,4.018L2.787,4.1A4.426,4.426,0,0,0,.01,8.507q1.949,28.655,1.825,57.2Q1.787,76.8,1.414,87.851A18.623,18.623,0,0,0,19.439,107.06Q20.145,107.083,20.851,107.054Z",
    transform: "translate(32.474 186.346)",
    fill: "#292560",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-43",
    "data-name": "Shape",
    d: "M0,21.01c10.133,4.021,24.761,12.626,34.332,17.513L6.654,53.28l.167.427q3.43,8.7,6.856,12.575l6.636-2.4c17.82-6.454,34.567-12.951,39.3-22.449C64.923,30.764,41.395,13.589,22.334,0Z",
    transform: "translate(75.13 269.148)",
    fill: "#292560",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-44",
    "data-name": "Shape",
    d: "M47.323,17.8V1.771A1.774,1.774,0,0,0,45.546,0H.018q-.4,8.776,7.936,9.839l.169.021a39.87,39.87,0,0,1,14.669,5.2,5.088,5.088,0,0,1,1.967,3.306A1.776,1.776,0,0,0,26.482,19.7h5.413a1.776,1.776,0,0,0,1.732-1.371q.916-3.94,5.886-4.325Q45.287,13.557,47.323,17.8Z",
    transform: "translate(4.952 0)",
    fill: "#0f0a57",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-45",
    "data-name": "Shape",
    d: "M20.469,33.692l.967-17.086c.393-4.428,1.8-7.3,5.274-7.613C21.235.819,14.266-.521,8.847.15S-1.57,3.454.463,10.219c2.575.193,3.576,1.426,3.576,3.484V31.164Z",
    transform: "translate(53.264 283.247)",
    fill: "#ffd3c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-46",
    "data-name": "Shape",
    d: "M.008,0Q-.184,7.766,4.282,9.81l.334.149c3.34,1.492,7.189,3.692,8.589,6.556a9.467,9.467,0,0,1,.644,1.844A1.776,1.776,0,0,0,15.574,19.7H23.4a1.776,1.776,0,0,0,1.747-1.443q.692-3.661,3.476-4.41c3.3-.886,6.7,1.987,6.7,5.853V1.778A1.775,1.775,0,0,0,33.548.007Z",
    transform: "translate(60.496 0)",
    fill: "#0f0a57",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-47",
    "data-name": "Shape",
    d: "M17.8,16.109Q14.052-.168,0,0l0,.01C2.577.205,3.579,1.439,3.579,3.5v8.677l.468.319q1.54,1.042,3.313,2.171Z",
    transform: "translate(53.725 293.454)",
    fill: "#e6b3a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-48",
    "data-name": "Shape",
    d: "M4.06,16.985l2.7,8.616Q6.055,5.622.327,0L0,10.285Z",
    transform: "translate(73.897 307.317)",
    fill: "#7c3a3a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-49",
    "data-name": "Shape",
    d: "M3.855,0Q-.81,4.229.17,12.679l7.387-.949Z",
    transform: "translate(39.419 321.566)",
    fill: "#430a0a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-50",
    "data-name": "Shape",
    d: "M17.1,43.386A16.447,16.447,0,0,0,33.566,26.97l-.7-13.358C32.863,6.206,25.865,0,17.1,0,9.332,0,2.265,2.75,1.26,13.507l-1.2,13.5C-.8,36.637,8.018,43.386,17.1,43.386Z",
    transform: "translate(41.987 297.951)",
    fill: "#ffd3c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-51",
    "data-name": "Shape",
    d: "M40.41,0,37.2,1.718l-2.013.105h0q-.229,6.74-3.265,8.643l.231,4.4Q4.485,11.117.563,21.685C-3.358,32.252,14.32,33.4,19.011,33.153s16.914-2.435,19.05-9.159q5.034-1.047,4.725-6.927l-.023-.4A148.524,148.524,0,0,0,40.41,0Z",
    transform: "translate(37.893 316.206)",
    fill: "#7c3a3a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-52",
    "data-name": "Shape",
    d: "M0,.544.333,6.872h0l.007.12C.452,8.41,1.523,10.65,4.432,8.615,7.4,6.538,5.857-2.251,0,.544Z",
    transform: "translate(74.521 312.422)",
    fill: "#ffd3c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-53",
    "data-name": "Shape",
    d: "M21.171.023,20.225.008C16.485-.042,3.211,0,.712,4.389c-2.84,4.989,3.325,6.234,9.58,6.542S21.171.023,21.171.023Z",
    transform: "translate(34.383 330.091)",
    fill: "#7c3a3a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-54",
    "data-name": "Shape",
    d: "M2.345.089c1.322.328,1.377,1.231,1.1,2.358S2.253,4.415,1.381,4.2,0,3.033,0,1.69,1.024-.239,2.345.089Z",
    transform: "translate(52.382 302.767)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Women-holding-tablet",
    transform: "translate(130.556 8.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-55",
    "data-name": "Shape",
    d: "M72.421,427.574,71.5,443.183l-15.669,5.246-13.605-4.563,6.5-2.65a8.806,8.806,0,0,0,5.751-8.254Q54.772,427.027,72.421,427.574Z",
    transform: "translate(-11.602 -116.014)",
    fill: "#ffd3c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-56",
    "data-name": "Shape",
    d: "M64.11,458.054l2.065,2.631-.122,2.248a1.547,1.547,0,0,1-1.526,1.466l-41.851.443a1.547,1.547,0,0,1-1.561-1.534c0-.039,0-.078,0-.117l.113-1.739,1.534-1.17Z",
    transform: "translate(-5.873 -124.298)",
    fill: "#524d97",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-57",
    "data-name": "Shape",
    d: "M142.539,460.659l3.826,1.159v2.612a.884.884,0,0,1-.871.886l-20.259.26a.884.884,0,0,1-.892-.83l0-.056h0v-2.53Z",
    transform: "translate(-33.884 -125.004)",
    fill: "#524d97",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-58",
    "data-name": "Shape",
    d: "M146.253,458.219q.738-3.739-1.191-10.822l-20.353.883a26.477,26.477,0,0,0-.48,10.281Z",
    transform: "translate(-33.773 -121.406)",
    fill: "#0f0a57",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-59",
    "data-name": "Shape",
    d: "M143.287,447.167a2.4,2.4,0,0,0,1.972-3.051,17.713,17.713,0,0,1-2.368-7.446l-.456-.07q-11.1-1.668-16.048.68c0,3.621-1.186,6.046-1.455,8.166-.266,2.1,4.765,3.408,9.3,3.108l.137-.01A38.343,38.343,0,0,0,143.287,447.167Z",
    transform: "translate(-34.042 -118.288)",
    fill: "#ffd3c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-60",
    "data-name": "Shape",
    d: "M65.137,446.5q-5.515,3.244-16.033,3.5c-10.518.252-8.216-2.893-6-3.7l-.686.178-.681.18-.676.181-.663.18A70.51,70.51,0,0,0,27.3,451.645l-.2.107-.284.153c-4.57,2.466-5.577,3.586-5.541,6.357l44.943-.767L66.4,450.8l.049-2.13q.016-.794.017-1.163Q66.47,446.011,65.137,446.5Z",
    transform: "translate(-5.916 -121.106)",
    fill: "#0f0a57",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-61",
    "data-name": "Shape",
    d: "M63.113,70.874a41.19,41.19,0,0,0,5.57-25.044C67.089,31.663,58.411,8.3,79.45,1.691L91.01,74.5Z",
    transform: "translate(-17.269 -0.459)",
    fill: "#7c3a3a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-62",
    "data-name": "Shape",
    d: "M131.855,92.008q12.747-17.223,2.128-30.463c-10.619-13.24-11.98-15.88-12.9-30.523l-13.353-6.7L102.35,49.667Z",
    transform: "translate(-27.917 -6.601)",
    fill: "#7c3a3a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-63",
    "data-name": "Shape",
    d: "M90.161,243.653q1.362,20.717,5.969,48.584,3.693,24.978,9.246,84.438,3.874,2.217,10.069,1.413t8.962-2.477q1.807-58.048-1.291-83.374,5.484-49.62,0-79.631L59.687,211.7a426.148,426.148,0,0,0-8.239,75.408l3.98,89.569q3.042,2.4,9.419,2.862t10.288-1.23q5.366-65.5,1.393-86.069A403.62,403.62,0,0,0,90.161,243.653Z",
    transform: "translate(-14.104 -57.447)",
    fill: "#fe9b04",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-64",
    "data-name": "Shape",
    d: "M86.825,254.06c2.876,1.109,9,1.458,12.936,1.088l-.175.806q-3.324,15.242-7.6,29.674l-.027.007,4.069-27.846Q89.646,257.294,86.825,254.06Z",
    transform: "translate(-23.704 -68.942)",
    fill: "#d57100",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-65",
    "data-name": "Shape",
    d: "M81.655,78.3l25.018,1.03a20.342,20.342,0,0,1,19.449,21.189q-.01.246-.026.492l-.158,2.441q-.745,11.577-1.544,25.137a296.78,296.78,0,0,0,2.63,48.117l.073.559a4.43,4.43,0,0,1-2.82,4.721q-9.543,3.606-30.24,2.881-20.979-.735-32.182-5.037l-.225-.087a4.431,4.431,0,0,1-2.736-4.947q4.325-23.024,4.609-54.741Q63.41,109.6,62.434,98.524A18.541,18.541,0,0,1,81.655,78.3Z",
    transform: "translate(-16.104 -21.244)",
    fill: "#4849e1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-66",
    "data-name": "Shape",
    d: "M90.383,163.569l17.808,1.352,24.834,5.258q.2,5.241.612,10.7-5.541,1.92-11.753-1.035l-.749-.358Q111.9,175.036,90.383,163.569Z",
    transform: "translate(-24.67 -44.386)",
    fill: "#2425b9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-67",
    "data-name": "Shape",
    d: "M53.008,125.764q-.593.932-9.915,10.371l-10.541-13.3,10.541-11.277Q53.6,124.833,53.008,125.764Z",
    transform: "translate(-8.976 -30.272)",
    fill: "#ffd3c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-68",
    "data-name": "Shape",
    d: "M74.475,78.324q-17.9,1.144-29.483,18.218Q43.3,99.03,40.081,103.8l14.551,16,7.3-10.384Z",
    transform: "translate(-11.02 -21.254)",
    fill: "#4849e1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-69",
    "data-name": "Shape",
    d: "M108.221,45.681l.96,17.091c.39,4.429,1.779,7.385,5.237,7.615a16.364,16.364,0,0,1-18.987,16.05c-11.958-1.556-9.818-12.016-8.491-16.972,3.988-.245,4.965-1.731,4.965-3.789V48.21Z",
    transform: "translate(-23.449 -12.396)",
    fill: "#ffd3c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-70",
    "data-name": "Shape",
    d: "M108.858,51.661l.048.846-.059.279q-3.852,17.869-21.514,18.3C89.889,70.9,92.3,69.357,92.3,67.3V58.364l.545-.332q1.515-.919,3.211-1.9Z",
    transform: "translate(-23.842 -14.019)",
    fill: "#e6b3a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-71",
    "data-name": "Shape",
    d: "M87.316,9.87A16.385,16.385,0,0,1,104.5,25.411V38.792c.386,7.4-9.721,14.017-14.923,14.419-3.759.266-14.854-1.974-16.412-12.667l-1.9-13.422C69.918,17.547,78.311,10.344,87.316,9.87Z",
    transform: "translate(-19.444 -2.672)",
    fill: "#ffd3c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-72",
    "data-name": "Shape",
    d: "M87.9,56.806q-2.121.727-1.887,2.211c.231,1.462,1.145,1.822,2.919,1.555l.082-.013c1.827-.29,3.894.553,3.607-2.239Q92.339,55.529,87.9,56.806Z",
    transform: "translate(-23.478 -15.306)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-73",
    "data-name": "Shape",
    d: "M103.906,27.8l-.433,2.879a5.808,5.808,0,0,1-1.648-3.921V21.183q-16.008-.922-21.657-9.526-9.19,4.671-9.157,11.088Q68.47,2.642,85.817.269c17.347-2.373,26.677,11.388,26.677,24.152Z",
    transform: "translate(-19.324 0)",
    fill: "#7c3a3a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-74",
    "data-name": "Shape",
    d: "M116.081,37.944c0-1.412.922-3.839,3.975-1.92s1.98,10.78-3.975,8.294Z",
    transform: "translate(-31.643 -9.583)",
    fill: "#ffd3c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-75",
    "data-name": "Shape",
    d: "M2.191,110.037H34.224a2.207,2.207,0,0,1,2.12,1.6l11.979,41.806a1.11,1.11,0,0,1-.134.907l-.946,1.469-31.626-.583a2.207,2.207,0,0,1-2.066-1.556L.493,111.6,1.3,110.49A1.1,1.1,0,0,1,2.191,110.037Z",
    transform: "translate(-0.277 -29.86)",
    fill: "#aeaeca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-76",
    "data-name": "Shape",
    d: "M1.3,111.556H33.043a2.207,2.207,0,0,1,2.12,1.6L47.3,155.314a1.1,1.1,0,0,1-1.06,1.415H14.5a2.207,2.207,0,0,1-2.12-1.6L.24,112.971a1.1,1.1,0,0,1,1.06-1.415Z",
    transform: "translate(-0.196 -30.272)",
    fill: "#d9d9e0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-77",
    "data-name": "Shape",
    d: "M28.626,141.99c2.455,0,3.862-1.983,3.142-4.429a6.418,6.418,0,0,0-5.748-4.429c-2.455,0-3.862,1.983-3.142,4.429A6.418,6.418,0,0,0,28.626,141.99Z",
    transform: "translate(-6.3 -36.127)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-78",
    "data-name": "Shape",
    d: "M123.719,117.214l-4.9,29.09L93.168,140.9l34.557,12.647Z",
    transform: "translate(-25.425 -31.807)",
    fill: "#2425b9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-79",
    "data-name": "Shape",
    d: "M91.167,157.554l-.144-.085a57.5,57.5,0,0,0-9.718-4.3l-1.9.14c-3.852.276-7.967.4-11.168-1.859a3.626,3.626,0,0,1-1.073-5.016,2.392,2.392,0,0,1-.729-4.167c-2.539-1.191-5.063-2.031-7.45-3.048-3.545-1.51-1.963-4.131.625-3.347l.163.052c2.911.91,16.81,3.562,24.006,6.956l.216.1a62.946,62.946,0,0,0,8.969,2.922l19.793,5.332,1.563-26,17.555,1.6-.271,3.577c-.469,8.078-1.2,24.616-3.56,31.641-2.075,6.167-10.185,8.64-36.877-4.495l-.144-.085Z",
    transform: "translate(-15.591 -33.983)",
    fill: "#ffd3c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-80",
    "data-name": "Shape",
    d: "M125.044,79.589q28.915,2.852,26.618,33.8l-.939,12.707-19.3-2.179,1.4-28.225Z",
    transform: "translate(-34.075 -21.597)",
    fill: "#4849e1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-81",
    "data-name": "Shape",
    d: "M19.222,151.755a1.253,1.253,0,0,1-1.151,1.143l-6.951.531A3.31,3.31,0,0,1,7.678,151l-1.793-6.527a3.094,3.094,0,0,1,2.72-3.913l10.947-.92a1.425,1.425,0,0,1,1.533,1.254l.007.071h0a1.553,1.553,0,0,1-1.329,1.648L10,144l12.093-.475a1.458,1.458,0,0,1,1.51,1.359,1.416,1.416,0,0,1-1.31,1.513l-12.067.847,10.036.14a1.387,1.387,0,0,1,1.362,1.293,1.236,1.236,0,0,1-1.144,1.32l-.04,0h0l-9.122.339,6.93.311a1.021,1.021,0,0,1,.972,1.067l0,.043Z",
    transform: "translate(-1.71 -37.891)",
    fill: "#ffd3c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-82",
    "data-name": "Shape",
    d: "M64.283,123.056l-.721-13.469-1.455,16.575Z",
    transform: "translate(-16.997 -29.737)",
    fill: "#2425b9",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Photo",
    transform: "translate(346.09 59.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-83",
    "data-name": "Shape",
    d: "M0,0H62.223V69.727H0Z",
    fill: "#e68e60",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-84",
    "data-name": "Shape",
    d: "M6.035,6.1H59.464V66.94H6.035Z",
    transform: "translate(-1.638 -1.654)",
    fill: "#ebf4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Shape-85",
    "data-name": "Shape",
    cx: 5.057,
    cy: 5.107,
    rx: 5.057,
    ry: 5.107,
    transform: "translate(21.108 13.102)",
    fill: "#fe9b04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-86",
    "data-name": "Shape",
    d: "M20.821,79.18l25-27.98L63.476,66.582v12.6Z",
    transform: "translate(-5.65 -13.894)",
    fill: "#2cb3a0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-87",
    "data-name": "Shape",
    d: "M6.035,81.992l19.9-20.43,19.9,20.43Z",
    transform: "translate(-1.638 -16.705)",
    fill: "#4ad9c5",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Certificate",
    transform: "translate(260.839 7.958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-88",
    "data-name": "Shape",
    d: "M0,0H62.223V69.727H0Z",
    fill: "#e68e60",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-89",
    "data-name": "Shape",
    d: "M6.035,6.1H59.464V66.94H6.035Z",
    transform: "translate(-1.638 -1.654)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-90",
    "data-name": "Shape",
    d: "M65.626,65.524a4.127,4.127,0,0,1,2.492,7.371l1.576,3.941-4.068,1.79-4.068-1.79,1.576-3.941a4.127,4.127,0,0,1,2.492-7.371Z",
    transform: "translate(-16.704 -17.781)",
    fill: "#fe9b04",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-91",
    "data-name": "Shape",
    d: "M12.07,12.19H40.653v3.331H12.07Z",
    transform: "translate(-3.275 -3.308)",
    fill: "#e5e5ed",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-92",
    "data-name": "Shape",
    d: "M12.07,22.857H56.7v3.331H12.07Z",
    transform: "translate(-3.275 -6.203)",
    fill: "#e5e5ed",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-93",
    "data-name": "Shape",
    d: "M12.07,33.524H31.2v3.331H12.07Z",
    transform: "translate(-3.275 -9.097)",
    fill: "#e5e5ed",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-94",
    "data-name": "Shape",
    d: "M12.07,44.19h37.6v3.331H12.07Z",
    transform: "translate(-3.275 -11.992)",
    fill: "#e5e5ed",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-95",
    "data-name": "Shape",
    d: "M12.07,54.857H56.7v3.331H12.07Z",
    transform: "translate(-3.275 -14.886)",
    fill: "#e5e5ed",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-96",
    "data-name": "Shape",
    d: "M12.07,65.524H36.036v3.331H12.07Z",
    transform: "translate(-3.275 -17.781)",
    fill: "#e5e5ed",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Desk",
    transform: "translate(243.352 228.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-97",
    "data-name": "Shape",
    d: "M236.9,131.68H222.683l8.886,25.621h7.109Z",
    transform: "translate(-60.427 -35.733)",
    fill: "#0f0a57",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-98",
    "data-name": "Shape",
    d: "M185.681,131.68H171.463l8.886,25.621h7.109Z",
    transform: "translate(-46.528 -35.733)",
    fill: "#0f0a57",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-99",
    "data-name": "Shape",
    d: "M75.925,131.68H61.707V157.3h7.109Z",
    transform: "translate(-16.745 -35.733)",
    fill: "#0f0a57",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-100",
    "data-name": "Shape",
    d: "M21.534,131.68H7.317V157.3h7.109Z",
    transform: "translate(-1.986 -35.733)",
    fill: "#0f0a57",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-101",
    "data-name": "Shape",
    d: "M7.317,0H180.236a3.544,3.544,0,0,1,3.554,3.534V97.361a3.544,3.544,0,0,1-3.554,3.534H7.317Z",
    transform: "translate(-1.986)",
    fill: "#ca6d3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-102",
    "data-name": "Shape",
    d: "M3.554,0H151.593a3.544,3.544,0,0,1,3.554,3.534V97.361a3.544,3.544,0,0,1-3.554,3.534H3.554A3.544,3.544,0,0,1,0,97.361V3.534A3.544,3.544,0,0,1,3.554,0Z",
    fill: "#e68e60",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-103",
    "data-name": "Shape",
    d: "M17.858,13.338H144.57a4.43,4.43,0,0,1,4.443,4.417V42.6a4.43,4.43,0,0,1-4.443,4.417H17.858A4.43,4.43,0,0,1,13.415,42.6V17.755A4.43,4.43,0,0,1,17.858,13.338Z",
    transform: "translate(-3.64 -3.619)",
    fill: "#ca6d3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-104",
    "data-name": "Shape",
    d: "M18.519,15.763a2.658,2.658,0,0,0-2.666,2.65V43.257a2.658,2.658,0,0,0,2.666,2.65H145.232a2.658,2.658,0,0,0,2.666-2.65V18.413a2.658,2.658,0,0,0-2.666-2.65Z",
    transform: "translate(-4.302 -4.277)",
    fill: "#f0996c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Shape-105",
    "data-name": "Shape",
    cx: 6.398,
    cy: 6.361,
    rx: 6.398,
    ry: 6.361,
    transform: "translate(71.264 20.144)",
    fill: "#ca6d3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-106",
    "data-name": "Shape",
    d: "M17.858,78.814H144.57a4.43,4.43,0,0,1,4.443,4.417v24.844a4.43,4.43,0,0,1-4.443,4.417H17.858a4.43,4.43,0,0,1-4.443-4.417V83.231A4.43,4.43,0,0,1,17.858,78.814Z",
    transform: "translate(-3.64 -21.387)",
    fill: "#ca6d3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-107",
    "data-name": "Shape",
    d: "M18.519,81.239a2.658,2.658,0,0,0-2.666,2.65v24.844a2.658,2.658,0,0,0,2.666,2.65H145.232a2.658,2.658,0,0,0,2.666-2.65V83.889a2.658,2.658,0,0,0-2.666-2.65Z",
    transform: "translate(-4.302 -22.045)",
    fill: "#f0996c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Shape-108",
    "data-name": "Shape",
    cx: 6.398,
    cy: 6.361,
    rx: 6.398,
    ry: 6.361,
    transform: "translate(71.264 67.852)",
    fill: "#ca6d3c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Book-Horisontal",
    transform: "translate(319.859 193.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-109",
    "data-name": "Shape",
    d: "M12.308,31.587H73.513V43.095H12.308Z",
    transform: "translate(-3.34 -8.571)",
    fill: "#f6f6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-110",
    "data-name": "Shape",
    d: "M67.385,31.587H88.459V43.095H67.385Z",
    transform: "translate(-18.286 -8.571)",
    fill: "#d9d9e0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-111",
    "data-name": "Shape",
    d: "M12.308,31.587H75.755v2.256H14.55v6.995H75.755v2.256H12.308Z",
    transform: "translate(-3.34 -8.571)",
    fill: "#b4b4e9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-112",
    "data-name": "Shape",
    d: "M12.308,31.587H52.439v2.256H14.55v6.995H52.439v2.256H12.308Z",
    transform: "translate(-3.34 -8.571)",
    fill: "#cfcff8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-113",
    "data-name": "Shape",
    d: "M2.154,15.794H61.79V27.3H2.154Z",
    transform: "translate(-0.584 -4.286)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-114",
    "data-name": "Shape",
    d: "M55.077,15.794H76.151V27.3H55.077Z",
    transform: "translate(-14.946 -4.286)",
    fill: "#d9d9e0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-115",
    "data-name": "Shape",
    d: "M0,15.794H63.448V18.05H2.242v6.995H63.448V27.3H0Z",
    transform: "translate(0 -4.286)",
    fill: "#3637cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-116",
    "data-name": "Shape",
    d: "M12.308,0H72.392V11.508H12.308Z",
    transform: "translate(-3.34)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-117",
    "data-name": "Shape",
    d: "M65.846,0H86.921V11.508H65.846Z",
    transform: "translate(-17.868)",
    fill: "#d9d9e0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-118",
    "data-name": "Shape",
    d: "M10.769,0H74.217V2.256H13.011V9.251H74.217v2.256H10.769Z",
    transform: "translate(-2.922)",
    fill: "#d57100",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-119",
    "data-name": "Shape",
    d: "M10.769,0H50.9V2.256H13.011V9.251H50.9v2.256H10.769Z",
    transform: "translate(-2.922)",
    fill: "#fe9b04",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-120",
    "data-name": "Shape",
    d: "M0,15.794H40.131V18.05H2.242v6.995H40.131V27.3H0Z",
    transform: "translate(0 -4.286)",
    fill: "#4849e1",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plant-3",
    transform: "translate(269.583 93.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-121",
    "data-name": "Shape",
    d: "M19.062,131.109H35.709l-2.663,39.325H21.725Z",
    transform: "translate(-5.173 -35.578)",
    fill: "#ff5711",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Shape-122",
    "data-name": "Shape",
    cx: 8.323,
    cy: 0.729,
    rx: 8.323,
    ry: 0.729,
    transform: "translate(13.889 94.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-123",
    "data-name": "Shape",
    d: "M23.034,102.138q-2.889-41.919-4.321-45.925C17.282,52.206,11.2,42.944,9.9,40.43s-1.863-8.875,0-15.475a53.416,53.416,0,0,0,8.293,14.016c4.846,5.743,4.03,12.336,2.427,17.567q3.39,36.937,4.187,45.6Z",
    transform: "translate(-2.36 -6.772)",
    fill: "#419428",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-124",
    "data-name": "Shape",
    d: "M9.9,24.955l-.055.387C8.62,34.485,13.071,42.384,16,47.2a18.6,18.6,0,0,1,2.926,9.488v.284a6.957,6.957,0,0,0-.21-.755C17.282,52.206,11.2,42.944,9.9,40.43S8.033,31.556,9.9,24.955Z",
    transform: "translate(-2.36 -6.772)",
    fill: "#46ad26",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-125",
    "data-name": "Shape",
    d: "M21.34,114.369l-5.02-22.5q1.75-7.065-2.39-10.292C9.79,78.347.166,73.219.166,70.028q-.9,2.926,3.105,6.58T15.055,92.2l4.972,22.17Z",
    transform: "translate(0 -19.003)",
    fill: "#24710d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-126",
    "data-name": "Shape",
    d: "M.185,70.144l.02-.115c0,3.19,9.624,8.318,13.764,11.546q4.1,3.2,2.425,10.151l-.034.141q-.092-7.21-5.345-10.328l-.426-.249C5.365,78.221-.391,73.881.185,70.144l.02-.115Z",
    transform: "translate(-0.039 -19.003)",
    fill: "#46ad26",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-127",
    "data-name": "Shape",
    d: "M20.361,123.037q-3.993-11.638-7.87-12.722c-3.877-1.084-9-2.914-11.262-8.344q13.275,1.483,14.46,8.923a30.6,30.6,0,0,1,5.486,12.142Z",
    transform: "translate(-0.334 -27.671)",
    fill: "#419428",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-128",
    "data-name": "Shape",
    d: "M1.229,101.971q13.1,1.464,14.426,8.726l.034.2q-2.848-3.975-5.474-4.777l-.514-.159c-2.584-.809-6.512-2.194-8.3-3.823Z",
    transform: "translate(-0.334 -27.671)",
    fill: "#46ad26",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-129",
    "data-name": "Shape",
    d: "M31.856,123.037h.814l.16-.461q3.911-11.2,7.71-12.261l.352-.1c3.829-1.1,8.712-2.977,10.91-8.244q-13.275,1.483-14.46,8.923A30.6,30.6,0,0,0,31.856,123.037Z",
    transform: "translate(-8.644 -27.671)",
    fill: "#419428",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-130",
    "data-name": "Shape",
    d: "M53.844,101.971l-.088.1c-2.856,3.279-4.293,3.592-8.077,4.36a9.773,9.773,0,0,0-6.212,4.34l-.083.122.025-.148Q40.7,103.44,53.844,101.971Z",
    transform: "translate(-10.687 -27.671)",
    fill: "#46ad26",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-131",
    "data-name": "Shape",
    d: "M28.6,95.366q.873-33.836,3.207-59.815-4.13-11.673.39-18.786C36.72,9.653,42.16,4.189,41.6,0q5.079,16.256.385,22.929t-8.8,12.623Q30.2,69.774,30.2,95.366Z",
    transform: "translate(-7.762 0)",
    fill: "#24710d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-132",
    "data-name": "Shape",
    d: "M43.3,0q5.079,16.256.385,22.929L42.356,24.82Q38.4,30.451,34.883,35.552a35.215,35.215,0,0,1,5.352-12.523l.309-.428c3.281-4.574,5.091-8.052,2.829-22.157Z",
    transform: "translate(-9.466 0)",
    fill: "#46ad26",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-133",
    "data-name": "Shape",
    d: "M32.052,109.764q1.309-18.964,4.383-29.67,3.8-1.61,8.461-7.254c4.657-5.644,8.487-11.253,7.012-19.783a23.147,23.147,0,0,1-7.636,7.184,20.194,20.194,0,0,0-9.164,19.853,162.275,162.275,0,0,0-4.072,29.664h.474Z",
    transform: "translate(-8.422 -14.398)",
    fill: "#419428",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-134",
    "data-name": "Shape",
    d: "M53.354,53.057l-.082.315c-1.664,6.2-4.764,6.846-10.193,11.6Q37.667,69.715,36.6,79.693l-.041.4-.04-.323a20.215,20.215,0,0,1,9.058-19.445l.146-.085a23.008,23.008,0,0,0,7.39-6.831Z",
    transform: "translate(-9.869 -14.398)",
    fill: "#46ad26",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-135",
    "data-name": "Shape",
    d: "M32.083,116.728q.859-12.389,9.56-23,7.724-3.058,10.214-8.456t6.86-6.549q-14,.4-18.089,14.15-8.921,12.027-9.48,23.845h.559Z",
    transform: "translate(-8.453 -21.362)",
    fill: "#24710d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-136",
    "data-name": "Shape",
    d: "M62.34,78.771l.284-.051q-4.315,1.136-6.8,6.411l-.064.138q-2.449,5.309-9.961,8.354h-.26a18.978,18.978,0,0,0,4.849-6.007l.113-.217c1.832-3.542,2.731-6.969,11.834-8.629l.284-.051Z",
    transform: "translate(-12.358 -21.362)",
    fill: "#46ad26",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Linha_355",
    "data-name": "Linha 355",
    x2: 715.606,
    transform: "translate(0 350.426)",
    fill: "none",
    stroke: "#bfbdb1",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignUnavailable);
export default __webpack_public_path__ + "static/media/Campaign Unavailable.c24f7105.svg";
export { ForwardRef as ReactComponent };